
<ng-container *ngIf="media && media.fields.file.contentType">
  <video 
    *ngIf="this.media.fields.file.contentType.match('video')"
    class="block-image is-full"
    [src]="lcpHelper.urlFromMedia(media)"
    loop="true" 
    playsinline
    preload="auto"
    muted
    >
    <!-- autoplay handled via ngAfterViewInit -->


    <source 
      [src]="lcpHelper.urlFromMedia(media)" 
      [type]="media.fields.file.contentType" />
    <!-- <source src="MY_VIDEO.webm" type="video/webm" /> -->
  </video>

  <!-- [class]="klass" -->

  <img     
    *ngIf="media.fields.file.contentType.match('image')"
    class="block-image is-full"
    [src]="lcpHelper.urlFromMedia(media)"
    [attr.srcset]="lcpHelper.srcsetFromMedia(media)"
    sizes="(min-width: 1600px) 1600px, 100vw">
</ng-container>